import { mergeFileText } from "@/tools/file/mailMergeInput";
import { canonTable } from "./seatingOps";
import { importRecords, type ImportContext, type ImportResult } from "./layouts";
import type { Guest } from "./types";

/** File types the guest import takes. Spreadsheets are read in the browser; nothing is uploaded. */
export const GUEST_IMPORT_ACCEPT = ".csv,.tsv,.txt,.xlsx,.xlsm,.xls,.ods,text/csv,text/plain";

export interface GuestFileResult extends ImportResult<Guest> { note: string }

/** Reads a CSV, TSV, text, XLSX, XLS or ODS file into guests (first visible sheet for a workbook). Never throws on bad data. */
export async function readGuestFile(file: File, ctx: ImportContext): Promise<GuestFileResult> {
  try {
    const { text, note } = await mergeFileText(file);
    const r = importRecords("guests", text, ctx);
    // "3" and "table 3" both become "Table 3", so a numbered column does not create tables that look different.
    r.records = r.records.map((g) => (g.table ? { ...g, table: canonTable(g.table) } : g));
    return { ...r, note };
  } catch (e) {
    return { records: [], issues: [{ row: 1, level: "error", message: e instanceof Error ? e.message : "That file could not be read." }], rowsRead: 0, rowsSkipped: 0, unknownColumns: [], note: "" };
  }
}
